import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Marquee from "@/components/Marquee";
import Hero from "@/components/sections/Hero";
import About from "@/components/sections/About";
import WhyICDH from "@/components/sections/WhyICDH";
import PortalDemo from "@/components/sections/PortalDemo";
import Programs from "@/components/sections/Programs";
import Professional from "@/components/sections/Professional";
import Admissions from "@/components/sections/Admissions";
import News from "@/components/sections/News";
import Gallery from "@/components/sections/Gallery";
import Alumni from "@/components/sections/Alumni";
import Careers from "@/components/sections/Careers";
import Donation from "@/components/sections/Donation";
import Contact from "@/components/sections/Contact";

export default function PublicSite() {
  useEffect(() => {
    const hash = window.location.hash.replace("#", "");
    if (hash) {
      setTimeout(() => {
        const el = document.getElementById(hash);
        if (el) window.__lenis ? window.__lenis.scrollTo(el, { offset: -80 }) : el.scrollIntoView();
      }, 600);
    }
  }, []);

  return (
    <div className="bg-icdh-white">
      <Navbar />
      <main>
        <Hero />
        <About />
        <WhyICDH />
        <PortalDemo />
        <Marquee />
        <Programs />
        <Professional />
        <Admissions />
        <News />
        <Gallery />
        <Alumni />
        <Careers />
        <Donation />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
